<script setup lang="ts">
import MecabForm from '@/Components/Mecab/MecabForm.vue';
import Bento2RowLayout from '@/Layouts/Bento/Bento2RowLayout.vue';
import Bento2RowModule from '@/Layouts/Bento/Bento2RowModule.vue';
import BentoFormModule from '@/Layouts/Bento/BentoFormModule.vue';
//import { Mecabable, NarrationFile, Output, Wordlist } from "@/Types/models";
import type { SharedProps } from '@/Types/inertia';
import { usePage } from '@inertiajs/vue3';
import { ref } from 'vue';

import { useI18n } from 'vue-i18n';

const page = usePage<SharedProps>();

const { t, locale } = useI18n({ useScope: 'global' });

locale.value = page.props.locale; // change!
// https://vue-i18n.intlify.dev/guide/advanced/composition#locale-changing
const setLanguage = ref(locale);

const blurb = t('Aiko Blurb');

// console.log("Current Locale:", locale.value);
// console.log("Messages for current locale:", messages.value[locale.value]);
// console.log("Messages loaded for 'es':", messages.value["es"]);
</script>

<template>
    <Bento2RowLayout>
        <template #header>
            <h2 class="text-base/7 font-semibold text-indigo-400">
                {{ t('Welcome') }}<br />
                {{ t('Japanese to Romaji and Hiragana Translation') }}
            </h2>
        </template>
        <Bento2RowModule
            :title="t('Learn Japanese Through Reading')"
            :subtitle="t('The Story of Aiko')"
            :description="blurb"
            image="/media/aiko_tokyo.jpg"
            moduleClass="col-span-1 lg:col-span-3"
            roundedClass="max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]"
        />
        <BentoFormModule
            title=""
            subtitle="Convert Japanese"
            description="Paste in your
            Japanese to get romaji / hiragana and spoken output"
            moduleClass="col-span-1 lg:col-span-3"
            roundedClass="lg:rounded-tr-[2rem]"
        >
            <MecabForm></MecabForm>
        </BentoFormModule>
    </Bento2RowLayout>
</template>
